(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["landing-base"] && !Shopify.designMode) return;
  try {
    /* Cualquier boton con data-lp-order lleva al selector de promocion y al boton de compra del producto. */
  (function () {
    if (window.__lpOrderBound) return;
    window.__lpOrderBound = true;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-lp-order]');
      if (!trigger) return;

      var target =
        document.querySelector('[id^="ProductInformation-"]') ||
        document.querySelector('form[action*="/cart/add"]');
      if (!target) return;

      event.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 96;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["producto-carrusel"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      if (root.__pcReady) return;
      var track = root.querySelector('[data-pc-track]');
      if (!track) return;
      var slides = [].slice.call(track.children);
      if (slides.length < 2) return;
      root.__pcReady = true;

      var dotsWrap = root.querySelector('[data-pc-dots]');
      var dots = [];

      function current() { return Math.round(track.scrollLeft / track.clientWidth); }
      function go(i) {
        var n = (i + slides.length) % slides.length;
        track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
      }
      function paint() {
        var c = current();
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === c); });
      }

      if (dotsWrap) {
        slides.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'pc__dot';
          b.setAttribute('aria-label', 'Ir a la foto ' + (i + 1));
          b.addEventListener('click', function (e) { e.preventDefault(); go(i); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      track.addEventListener('scroll', function () { requestAnimationFrame(paint); }, { passive: true });

      var prev = root.querySelector('[data-pc-prev]');
      var next = root.querySelector('[data-pc-next]');
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(current() - 1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(current() + 1); });

      paint();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-pc]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
